import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addStory } from 'slice/storySlice';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const Add = () => {
  const [formData, setFormData] = useState({
    heading: '',
    category: '',
    image: null,
    extraItems: []
  });

  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.story || {});
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, type, value, files } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'file' ? files[0] : value
    }));
  };

  const addExtraItem = () => {
    setFormData((prev) => ({
      ...prev,
      extraItems: [...prev.extraItems, { image: null, heading: '' }]
    }));
  };

  const removeExtraItem = (index) => {
    setFormData((prev) => ({
      ...prev,
      extraItems: prev.extraItems.filter((_, i) => i !== index)
    }));
  };

  const handleExtraChange = (index, field, value) => {
    setFormData((prev) => {
      const next = [...prev.extraItems];
      next[index] = { ...next[index], [field]: value };
      return { ...prev, extraItems: next };
    });
  };

  const fileToBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formDataToSend = new FormData();
    formDataToSend.append('heading', formData.heading);
    formDataToSend.append('category', formData.category);
    formDataToSend.append('image', formData.image);

    try {
      if (formData.extraItems.length > 0) {
        const images = await Promise.all(
          formData.extraItems.map(async (item) => (item.image ? await fileToBase64(item.image) : null))
        );
        const imageHeadings = formData.extraItems.map((item) => item.heading || '');
        formDataToSend.append('images', JSON.stringify(images));
        formDataToSend.append('image_headings', JSON.stringify(imageHeadings));
      }

      await dispatch(addStory(formDataToSend));
      toast.success('Story added successfully!');
      navigate('/story');
      setFormData({ heading: '', category: '', image: null, extraItems: [] });
    } catch (error) {
      console.error('Story add failed:', error);
      toast.error('Failed to add story');
    }
  };

  return (
    <div className="container-fluid mt-5">
      <div className="mainheadig mx-4">
        <h4 className="text-white font-weight-bold">Add Story</h4>
      </div>

      <form onSubmit={handleSubmit} encType="multipart/form-data">
        <div className="row mx-4">
          <div className="col-sm-12 mt-2">
            <label htmlFor="storyHeading" className="adminlables">
              Heading
            </label>
            <input
              type="text"
              id="storyHeading"
              name="heading"
              value={formData.heading}
              className="form-control"
              onChange={handleChange}
              required
            />
          </div>

          <div className="col-sm-6 mt-4">
            <label htmlFor="storyCategory" className="adminlables">
              Category
            </label>
            <select
              id="storyCategory"
              name="category"
              value={formData.category}
              className="form-control"
              onChange={handleChange}
              required
            >
              <option value="" disabled>
                Select category
              </option>
              <option value="desh">Desh</option>
              <option value="videsh">Videsh</option>
              <option value="sports">Sports</option>
              <option value="dharm">Dharm</option>
              <option value="cinema">Cinema</option>
            </select>
          </div>

          <div className="col-sm-6 mt-4">
            <label htmlFor="storyImage" className="adminlables">
              Image
            </label>
            <input
              type="file"
              id="storyImage"
              name="image"
              className="form-control btn-block filebg"
              accept="image/*"
              onChange={handleChange}
              required
            />
          </div>
        </div>

        <div className="row mx-4 mt-4">
          <div className="col-sm-12">
            <div className="d-flex justify-content-between align-items-center">
              <h6 className="text-white mb-2">Extra Images</h6>
              <button type="button" className="btn btn-sm btn-secondary" onClick={addExtraItem}>
                Add Image
              </button>
            </div>
          </div>
          {formData.extraItems.map((item, index) => (
            <div className="col-sm-12 mt-3" key={`extra-${index}`}>
              <div className="row">
                <div className="col-sm-6">
                  <label className="adminlables" htmlFor={`extraImage-${index}`}>
                    Extra Image
                  </label>
                  <input
                    type="file"
                    id={`extraImage-${index}`}
                    className="form-control filebg"
                    accept="image/*"
                    onChange={(e) => handleExtraChange(index, 'image', e.target.files[0])}
                    required
                  />
                </div>
                <div className="col-sm-5">
                  <label className="adminlables" htmlFor={`extraHeading-${index}`}>
                    Image Heading
                  </label>
                  <input
                    type="text"
                    id={`extraHeading-${index}`}
                    className="form-control"
                    value={item.heading}
                    onChange={(e) => handleExtraChange(index, 'heading', e.target.value)}
                    required
                  />
                </div>
                <div className="col-sm-1 d-flex align-items-end">
                  <button type="button" className="btn btn-danger btn-sm" onClick={() => removeExtraItem(index)}>
                    Remove
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-4 text-right mx-5">
          <button className="btn addbtn btn-lg" disabled={loading} type="submit">
            {loading ? 'Adding...' : 'Add Story'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default Add;
